import React from 'react';
import { Button } from 'reactstrap';
import { PinchView } from 'react-pinch-zoom-pan';
//import Swipeable from 'react-swipeable';

import '../styles/ImageView.css';

class ImageView extends React.Component {

	componentWillMount() {
		console.log('ImageView', this.props.images, this.props.index, this.props.isOpen);
	}

	_swipingLeft() {
		if(this.props.index < this.props.images.length - 1)
			this.props.setIndex(this.props.index + 1);
	}

	_swipingRight() {
		if (this.props.index > 0)
			this.props.setIndex(this.props.index - 1);
	}

	render() {
		let { isOpen, images, index } = this.props;

		//console.log('ImageView render: ', isOpen, images, index);
		//<img src={images[index].img} alt='image view' />

		if (!isOpen || images.length < 1){
			return (<div></div>);
		}

		return (
			<div className="imageView">
				<div className="sp-boximgview">
				<Button className="sp-view-close" onClick={this.props.toggle}>x</Button>
				<div className="sp-boximgnav">
					<Button
						disabled={this.props.index <= 0}
						onClick={() => this._swipingRight()}
					> <i className="ico-sp-cvleft"></i> </Button>

					<Button
						disabled={this.props.index >= this.props.images.length - 1}
						onClick={() => this._swipingLeft()}
					> <i className="ico-sp-cvright"></i> </Button>
				</div>
				<PinchView backgroundColor="#333" maxScale={3} initialScale={1} containerRatio={((400 / 600) * 100)}>
					<img src={images[index].src} alt={index} style={{
						margin: 'auto',
						width: 'auto',
						height: '100%'
					}} />
				</PinchView>
				</div>
			</div>
		);
	}
}

export default ImageView;


// WEBPACK FOOTER //
// ./src/components/ImageView.js